'use client'

import dynamic from 'next/dynamic'

const SidebarInner = dynamic(
  () => import('@/components/molecules/SideBar').then((mod) => mod.Sidebar),
  { ssr: false },
)

export const SidebarLazy = () => {
  return <SidebarInner />
}
